module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui basic news segment"
  }, [(_vm.loading) ? _c('loading-indicator') : _vm._e(), _vm._v(" "), (_vm.news.length > 0) ? _c('h2', {
    staticClass: "ui header"
  }, [_c('img', {
    staticClass: "ui image",
    attrs: {
      "src": "/images/logo.png"
    }
  }), _vm._v("\n    Neuerungen\n  ")]) : _vm._e(), _vm._v(" "), (_vm.news.length > 0) ? _c('div', {
    staticClass: "ui feed"
  }, _vm._l((_vm.news), function(item) {
    return _c('news-item', {
      key: item.id,
      attrs: {
        "item": item
      }
    })
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-5a0cfefa"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/news/components/list.vue
// module id = 358
// module chunks = 0